module.exports = __webpack_public_path__ + "img/c3.a2708382.jpg";